export enum WorkInstanceFieldValue {
    Plan = "CMPL", 
    CoCode = "COCD", 
    BankNumber = "REMT", 
    Ssn = "SSEC", 
    FirstName = "FNME",
    LastName = "LNME", 
    PolicyNumber = "POLN",
    PayorNumber = "CNTL",
    Agent = "AGT",
    StateSigned = "RESD",
    CaseNumber = "CASE"
}